/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useContext, Dispatch, SetStateAction, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { ContractFilters } from '@types'

type ContextState = {
  filters: ContractFilters
  setFilters: Dispatch<SetStateAction<ContractFilters>>
  isContractsSync: boolean
  setIsContractsSync: Dispatch<SetStateAction<boolean>>
  resetFilters: () => void
  resetTriggered: number
}

export const initialContractsFiltersState: ContextState = {
  filters: { page: 1, limit: 10, orderBy: 'ASC' },
  setFilters: () => {},
  isContractsSync: false,
  setIsContractsSync: () => {},
  resetFilters: () => {},
  resetTriggered: 0,
}

const ContractsContext = React.createContext<ContextState>(initialContractsFiltersState)

type ContractFiltersProviderProps = {
  children: React.ReactNode
}

export function ContractFiltersProvider({ children }: ContractFiltersProviderProps) {
  const [isContractsSync, setIsContractsSync] = useState<boolean>(false)
  const [filters, setFilters] = useState<ContractFilters>(initialContractsFiltersState.filters)
  const [resetTriggered, setResetTriggered] = useState<number>(0)
  const [search] = useSearchParams()

  const resetFilters = () => {
    setResetTriggered(state => state + 1)
  }

  useEffect(() => {
    if (resetTriggered) {
      setFilters(initialContractsFiltersState.filters)
    }
  }, [resetTriggered])

  useEffect(() => {
    if (filters) {
      if (search.get('service') && !filters.asnum) {
        const timeout = setTimeout(
          () =>
            setFilters(state => ({
              ...state,
              asnum: Number(search.get('service')) ?? undefined,
              page: initialContractsFiltersState.filters.page,
            })),
          0,
        )

        return () => clearTimeout(timeout)
      } else if (search.get('carrierId')) {
        const timeout = setTimeout(
          () =>
            setFilters(state => ({
              ...state,
              carrierId: Number(search.get('carrierId')) ?? undefined,
              page: initialContractsFiltersState.filters.page,
            })),
          0,
        )

        return () => clearTimeout(timeout)
      }
    } else {
      setFilters(initialContractsFiltersState.filters)
    }
  }, [search])

  return (
    <ContractsContext.Provider
      value={{
        filters,
        setFilters,
        isContractsSync,
        setIsContractsSync,
        resetFilters,
        resetTriggered,
      }}
    >
      {children}
    </ContractsContext.Provider>
  )
}

export function useContractContracts(): ContextState {
  const context = useContext(ContractsContext)
  if (!context)
    throw Error('This hook can only be used under the ContractFiltersProvider component')
  return context
}
